import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getClientListApi(data) {
  return axios.post(APP_SETTINGS.API_PATH.CLIENT.getClientList, data);
}
export function addNewClientApi(clientData) {
  return axios.post(APP_SETTINGS.API_PATH.CLIENT.addNewClient, clientData);
}
export function editClientApi(clientData) {
  return axios.post(APP_SETTINGS.API_PATH.CLIENT.updateClient, clientData);
}
export function deleteClientApi(clientId) {
  let url = `${APP_SETTINGS.API_PATH.CLIENT.deleteClient}?id=${clientId}`;
  return axios.delete(url);
}
